export default __webpack_public_path__ + "static/media/crown.ad662129.svg";